export const IMAGE_EDIT_MODAL = 'IMAGE_EDIT_MODAL'
export const PORTAL_IMAGE_STORE_MODAL = 'PORTAL_IMAGE_STORE_MODAL'
export const PORTAL_GALLERY_IMAGE_FORM_MODAL = 'PORTAL_GALLERY_IMAGE_FORM_MODAL'
export const PORTAL_LINK_IMAGE_FORM_MODAL = 'PORTAL_LINK_IMAGE_FORM_MODAL'
export const PORTAL_CREATE_MODAL = 'PORTAL_CREATE_MODAL'
export const IMAGE_ACTION_MODAL = 'IMAGE_ACTION_MODAL'
export const TOWN_BANNER_ITEM_MODAL = 'TOWN_BANNER_ITEM_MODAL'
export const LISTING_PORTAL_SEARCH_MODAL = 'LISTING_PORTAL_SEARCH_MODAL'
export const SHOW_QRCODE_MODAL = 'SHOW_QRCODE_MODAL'



// WEBPACK FOOTER //
// ./src/constants/modalType.js